// recoil/useAuthStore.ts
import { useRecoilState } from "recoil";
import { authState } from "./auth.state";
import { clearLocalStorageExceptSavedLoginInfo } from "../util/util";

export const useAuthStore = () => {
  const [auth, setAuth] = useRecoilState(authState);

  const login = (userId: string, role: "user" | "admin", token: string) => {
    setAuth({
      userId,
      role,
    });

    localStorage.setItem("jwtToken", token);
    localStorage.setItem("userId", userId);
    localStorage.setItem("role", role);
  };

  const logout = () => {
    clearLocalStorageExceptSavedLoginInfo();

    setAuth({
      userId: null,
      role: null,
    });
  };

  return {
    ...auth,
    login,
    logout,
  };
};
